module.exports = __webpack_public_path__ + "img/tuceng24.31eaa7c4.png";